export default "__VITE_ASSET__00ddc78e__"